export const mapsConstant = {
    DISABLE_MAP_BUTTON: "DISABLE_MAP_BUTTON",
    ENABLE_MAP_BUTTON: "ENABLE_MAP_BUTTON",
    TOGGLE_COLOR_FILL: "TOGGLE_COLOR_FILL",
    TOGGLE_IMAGES_CAPTIONS: "TOGGLE_IMAGES_CAPTIONS",
    TOGGLE_UPPERCASE: "TOGGLE_UPPERCASE"

};
